import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { ButtonText, Caption, ButtonOutlinedRounded } from '@comeon/ui';

import SidebarHeader from '~/components/header/sidebar-header';
import { SubTitleLight } from '~/components/misc/section-head';
import { Modal } from '~/components/modal/modal';
import breakpoint from '~/utils/style-utils';
import { sidebarTop } from '~/utils/layout-utils';
import { UIContextType } from '../../ui/ui-context';

export const ModalWrapper = styled(Modal)`
	right: 0;
	${breakpoint.lg`
			position: absolute;
			margin-top:0;
			height: inherit;
	`}
`;

interface IframeContainerProps {
	hasRegulationHeader?: boolean;
	uiContext: UIContextType;
}

export const FixedContainer = styled.div<IframeContainerProps>`
	position: fixed;
	right: 0;
	height: ${({ uiContext }) => (uiContext.hasStaticHeader ? `calc(100% - var(--regulationHeight))` : '100%')};
	top: ${props => (props.hasRegulationHeader ? 'var(--regulationHeight)' : '0px')};
	display: flex;
	flex-direction: column;
	width: 100%;

	${({ uiContext }) => css`
		${breakpoint.lg`
			position: fixed;
			// @ts-expect-error - $FixMe sidebar-header is js file
			height: calc(100% - ${sidebarTop(uiContext)});
			right: 0;
			top: ${sidebarTop(uiContext)};
			width: var(--detailWidth);
		`};
	`}

	iframe {
		flex: 1;
	}
`;

export const SidebarHeaderContainer = styled(SidebarHeader)`
	top: auto;
`;

interface AnimatedWrapperProps {
	iframeLoaded?: boolean;
}

export const AnimatedWrapper = styled(motion.div)<AnimatedWrapperProps>`
	position: fixed;
	bottom: 0;
	height: ${props => (props.iframeLoaded ? 'inherit' : '')};
	${breakpoint.sm`
    width: 100%;
  `};
	${breakpoint.lg`
    width: 377px;
  `};
`;

export const LimitContainer = styled.div`
	margin: 0 auto;
	background: var(--welcome-popup-bg);
	width: 100%;
	border-top-left-radius: 25px;
	border-top-right-radius: 25px;
	box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.25);
	padding: 18px 10px 12px 10px;
	text-align: left;

	@media screen and (max-width: 320px) {
		width: 303px;
	}

	@media screen and (max-width: 280px) {
		width: 283px; /* For Galaxy Fold */
	}

	${breakpoint.lg`
    position: static;
    display: inline-block;
  `};

	${breakpoint.md`
    bottom: 0;
  `};
`;

export const SubTitle = styled(SubTitleLight)`
	padding: 10px 18px;
`;

export const LimitList = styled.ul`
	padding: 10px 18px;
`;

export const LimitRemainingWrapper = styled.div`
	width: 100%;
	padding: 0 15px 15px 12px;
	font-size: 12px;
	margin-top: -10px;
	color: rgba(var(--font-supportive), 1);
	display: flex;
	justify-content: space-between;

	div {
		color: inherit;
	}
`;

export const InformationText = styled(Caption)`
	padding: 10px 40px;
	text-align: center;
`;

export const ButtonContainer = styled.section`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 10px 18px;
	align-items: center;

	.upload-btn {
		color: rgba(var(--primary), 1);
	}
`;

export const UploadOptionsContainer = styled.div`
	display: inline-flex;
	align-items: center;
	font-size: 14px;
	padding: 10px 18px;
`;

export const OrText = styled.span`
	margin-right: 5px;
`;

export const UploadLinkButton = styled(ButtonText)`
	font-size: 14px;
`;

export const CloseIconWrapper = styled.span`
	svg {
		width: 25px;
		height: 25px;
	}
	cursor: pointer;
	position: absolute;
`;

export const CloseButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 9%;
	right: 11%;
`;

export const ButtonOutlinedCustom = styled(ButtonOutlinedRounded)`
	color: var(--button-outlined-custom-color, rgba(var(--secondary), 1));
	border-color: var(--button-outlined-custom-border, rgba(var(--secondary), 1));
`;
